import { Grid, Paper, Skeleton, Stack } from '@mui/material';
import React from 'react';

// Loading placeholder that mirrors the dataset card layout to reduce layout shift.
const DatasetCardSkeleton: React.FC = () => (
  <Paper variant="outlined" sx={{ p: 2.5 }}>
    <Stack spacing={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
        <Stack spacing={0.5} sx={{ flex: 1 }}>
          <Skeleton variant="text" width="40%" height={28} />
          <Skeleton variant="text" width="55%" height={16} />
        </Stack>
      </Stack>
      <Stack direction="row" spacing={1}>
        <Skeleton variant="rounded" width={90} height={24} />
        <Skeleton variant="rounded" width={150} height={24} />
      </Stack>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Skeleton variant="rounded" height={40} />
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="rounded" height={40} />
        </Grid>
        <Grid item xs={12} md={5}>
          <Skeleton variant="rounded" height={40} />
        </Grid>
      </Grid>
      <Skeleton variant="rounded" height={300} />
    </Stack>
  </Paper>
);

export default DatasetCardSkeleton;
